import { render, staticRenderFns } from "./PUIPreview.vue?vue&type=template&id=50edad05&scoped=true&"
import script from "./PUIPreview.vue?vue&type=script&lang=js&"
export * from "./PUIPreview.vue?vue&type=script&lang=js&"
import style0 from "./PUIPreview.vue?vue&type=style&index=0&id=50edad05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edad05",
  null
  
)

export default component.exports